import { render, staticRenderFns } from "./WinnersList.vue?vue&type=template&id=1fcdba25&scoped=true&"
import script from "./WinnersList.vue?vue&type=script&lang=js&"
export * from "./WinnersList.vue?vue&type=script&lang=js&"
import style0 from "./WinnersList.vue?vue&type=style&index=0&id=1fcdba25&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcdba25",
  null
  
)

export default component.exports